export const Spinner = () => {
    return <img src="/images/spinner.svg" />;
};
